'use client';

import { use } from 'react';
import { PercentOffMsrpSelector } from '../../preferences/_components/PercentOffMsrpSelector';
import { StepContext } from './StepContext';

export const PercentOffMsrpStep = ({ initialValue }: { initialValue: number | null }) => {
  const { setIsDirty } = use(StepContext);
  return (
    <PercentOffMsrpSelector
      initialValue={initialValue}
      label="What is your preferred discount?"
      onChange={() => setIsDirty(true)}
    />
  );
};
